import { fls, flsPathSuffix, bucketName } from "@/config";

export default {
    getUrlByGenerateName (generateName, thumbnail = false) {
        if (!generateName) return;
        const splitArr = generateName.split('&bucketName=');
        let name = splitArr[0];
        let bucket = splitArr[1] || bucketName || 'grid';
        let url = `${fls}/${bucket}/`; // `${fls}/${bucketName}/${filePath}`
        if (flsPathSuffix) {
            if (thumbnail) {
                url += 'thumbnail-file' + '/' // 缩略图 `${fls}/${bucketName}/${flsPathSuffix}/${filePath}`
            } else {
                flsPathSuffix && (url += flsPathSuffix + '/'); // 原图 `${fls}/${bucketName}/${flsPathSuffix}/${filePath}`
            }
        }
        return (url + name)
    }
}
